module.exports = __webpack_public_path__ + "media/flags/007-malasya-1f369aed.svg";